// extracted by mini-css-extract-plugin
export default {"main":"Products_main__rXoYP","navCatalogo":"Products_navCatalogo__aILXq"};